import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail, Send } from "lucide-react";

export default function NewsletterWidget() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !email.includes("@")) {
      toast.error("Inserisci un'email valida");
      return;
    }
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email: email.trim() });
      toast.success("Iscrizione registrata. Grazie!");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="max-w-md">
      <div className="flex items-center gap-2 text-white/80 mb-2">
        <Mail className="w-4 h-4" />
        <span className="font-display text-sm uppercase tracking-widest">Newsletter</span>
      </div>
      <p className="text-white/60 text-sm mb-3">
        Ricevi aggiornamenti su normative e casi studio dell'iperammortamento. Zero spam.
      </p>
      <div className="flex flex-col sm:flex-row gap-2">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="La tua email"
          aria-label="Indirizzo email per la newsletter"
          data-testid="newsletter-email"
          className="flex-1 h-11 px-3 bg-white/5 border border-white/15 text-white placeholder:text-white/40 rounded focus:outline-none focus:border-brand text-sm"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit"
          aria-label="Iscriviti alla newsletter"
          className="h-11 px-5 bg-brand text-white rounded font-display uppercase tracking-widest text-sm hover:bg-brand-dark disabled:opacity-60 inline-flex items-center justify-center gap-2"
        >
          <Send className="w-4 h-4" /> {loading ? "..." : "Iscriviti"}
        </button>
      </div>
    </form>
  );
}
